<script setup lang="ts">
import CreateBotModal from '~/pages/bots/CreateBotModal.vue'

const modalOpen = defineModel<boolean>({ required: true })
</script>

<template>
  <CreateBotModal v-model="modalOpen" />
</template>
